module.exports = __webpack_public_path__ + "img/blog-4.c929e1c2.jpg";